// Thin progress bar. Omit `value` for an indeterminate sweep (loading,
// card processing); pass 0–100 for a determinate fill (printing).

export function ProgressBar({ value }: { value?: number }) {
  if (value === undefined) {
    return (
      <div className="progress progress--indeterminate" role="progressbar">
        <div className="progress__fill" />
      </div>
    );
  }
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={pct}
      className="progress"
      role="progressbar"
    >
      <div className="progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
